import { AlertCircle } from "untitledui-js-base";
import { FC } from "react";
import { Button, ButtonSize, ButtonVariant, Modal } from "shared/components";
import { useNavigate } from "react-router-dom";
import { useUnitsPropertiesDictionary } from "shared/hooks/use-units-properties";

interface RegroupWarningModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const RegroupWarningModal: FC<RegroupWarningModalProps> = ({
  isOpen,
  onClose
}) => {
  const navigate = useNavigate();
  const { property, properties } = useUnitsPropertiesDictionary();

  return (
    <Modal
      opened={isOpen}
      onClose={() => onClose()}
      panelClassName="p-6 max-w-[400px] w-full space-y-4"
    >
      <div className="rounded-full bg-alpha-40 p-4 mx-auto size-16">
        <AlertCircle size="32px" className="stroke-content-400" />
      </div>
      <div className="space-y-2">
        <h1 className="text-xl font-bold text-center">Regroup {properties}?</h1>
        <p className="text-center text-content-500 text-base">
          Regrouping will reset your current {property} group setup
        </p>
      </div>
      <div className="flex gap-2 w-full">
        <Button
          size={ButtonSize.BASE}
          variant={ButtonVariant.BASE}
          className="w-full"
          onClick={() => onClose()}
        >
          Cancel
        </Button>
        <Button
          size={ButtonSize.BASE}
          variant={ButtonVariant.PRIMARY}
          className="w-full"
          onClick={() => {
            onClose();
            navigate("/property-groups/configuration");
          }}
        >
          Proceed
        </Button>
      </div>
    </Modal>
  );
};
